import {call, put, takeEvery} from "redux-saga/effects";
import {CommonService} from "../../shared/services";
import {GET_AUTH_CASES_LIST, setAuthCasesList} from "../actions/dashboard.action";


function* getAuthCasesListDetails() {
    try {
        // @ts-ignore
        const resp = yield call(CommonService._dashboard.AuthCasesList);
        yield put(setAuthCasesList(resp?.data));
    } catch (error: any) {
        yield put(setAuthCasesList(error));
    }
}

export default function* dashboardSaga() {
    yield takeEvery(GET_AUTH_CASES_LIST, getAuthCasesListDetails);
}


